module.exports = __webpack_public_path__ + "img/media-oem.3d42bae6.svg";